import { LazyAction, LazyModule, LazyImport, createLazyComponent } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MobilityRead"*/ './lazyIndex')
);

export const MobilityInlineLocationRow = createLazyComponent(
    lazyModule,
    m => m.MobilityInlineLocationRow
);

export const MobilityPeekRow = createLazyComponent(lazyModule, m => m.MobilityPrepMessageRow);
export const MobilityPeekTripOriginRow = createLazyComponent(
    lazyModule,
    m => m.MobilityTripOriginRow
);

export let lazyFetchMobilityBookends = new LazyAction(lazyModule, m => m.fetchTravelBookendDetails);

export let lazyResetMobilityBookends = new LazyAction(lazyModule, m => m.resetTravelBookendDetails);

export let lazyHasTravelBookendData = new LazyImport(lazyModule, m => m.hasTravelBookendData);
